export class ChangeRequestTypes {
  ChangeRequestTypeID: number;
  ChangeRequestType: string;
  Status: boolean;
  CountryCode: number;
  JointApplicantCountryCode: number;
  ChangeRequestID: number;
}
